import { render, staticRenderFns } from "./AdVideo.vue?vue&type=template&id=be4f6fc2"
import script from "./AdVideo.vue?vue&type=script&lang=js"
export * from "./AdVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports